import { render } from "./MenuPage.vue?vue&type=template&id=bea72794"
import script from "./MenuPage.vue?vue&type=script&lang=js"
export * from "./MenuPage.vue?vue&type=script&lang=js"

import "./MenuPage.vue?vue&type=style&index=0&id=bea72794&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__